import { override } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import app from 'flarum/forum/app';

import ExtraHero from './components/ExtraHero';

export default function () {
  override(IndexPage.prototype, 'hero', function (hero) {
    const bannerUrl = app.forum.attribute('extraHeroBannerUrl');
    const bannerLink = app.forum.attribute('extraHeroBannerLink');
    const tagSlug = app.forum.attribute('extraHeroTagSlug');
    const sortType = app.forum.attribute('extraHeroSortType');

    if (!tagSlug || this.currentTag()) return hero();

    return [hero(), <ExtraHero bannerUrl={bannerUrl} bannerLink={bannerLink} tagSlug={tagSlug} sortType={sortType} />];
  });
}
